export default __webpack_public_path__ + "static/media/692.ce5999b4.png";